import { defaultFetch } from './baseApi';

type ProjectsStatsType = {
	totalAmount: number;
	totalApprovedAmount: number;
	selfFinancedAmount: number;
	finalAmount: number;
	cashedIn: number;
	advanceCashedIn: number;
	reportedAmount: number;
	requestedAmount: number;
	reportedIndirectCost: number;
	compliantAmount: number;
	inProgressAmount: number;
	notCompliantAmount: number;

	lastDateFtImport?: string | null;
	lastDateTsImport?: string | null;
	lastSalFt?: number | null;
	lastSalTs?: number | null;

	lastDateStatement?: string | null;
	lastSalStatement?: number | null;
};

export const getProjectsStats = () => {
	return defaultFetch<ProjectsStatsType>(`/v0/stats/projects`);
};

export const getProjectStats = (projectId: string) => {
	return defaultFetch<ProjectsStatsType>(`/v0/stats/projects/${projectId}`);
};
